import React from 'react';

const BoardConfirmIcon = ({ confirm }) => {
    return !confirm ? '' : <img src={`../../../common/images/confirm.png`} alt="" style={{ width: 30, marginRight: 4 }} />;
};

export default BoardConfirmIcon;
